import styles from "./TopBarHeaderEnd.module.scss"
import { TopBarHeaderEndProps } from "./TopBarHeaderEnd.types"

export default function TopBarHeaderEnd(props: TopBarHeaderEndProps) {
    const { children } = props

    return <div className={styles.base}>{children}</div>
}
